import { useState, useEffect } from 'react'
import { SwitchVerticalIcon, SearchIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid'
import classnames from 'classnames'
import { useTranslation } from '@utils/contexts';

const accessObject = (value, key) => {

  if (key?.toString().includes('.')) {
    const keys = key.split('.')
    let newVal = { ...value }

    keys.forEach(k => {
      if (newVal[k]) {
        newVal = newVal[k]
      } else {
        newVal = ''
      }
    });

    return newVal
  }

  return value[key]
}



export default function MyTable({ data, columns, CustomHeader = null }) {
  const { t } = useTranslation();
  const [order, setOrder] = useState({})
  const [localData, setLocalData] = useState([])
  const [filteredData, setFilterdData] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const [pagination, setPagination] = useState({ page: 1, show: 8 })

  useEffect(() => {
    setLocalData(data || [])
    setFilterdData(data || [])
  }, [data])

  const renderColumn = (item) => {
    return columns.map((c, idx) => {
      return (c.render) ?
        // custom TD
        <td key={`column_${idx}`} className="py-4 pl-8">
          {c.render(item)}
        </td>
        :
        // normal TD
        <td key={`column_${idx}`} className="py-4 pl-8">

          <p className="text-sm leading-none text-gray-600">{accessObject(item, c.key)}</p>
        </td>
    })
  }

  const filterItem = (obj, searchValue) => {
    const searchStr = searchValue.toLowerCase()
    console.log(searchStr)
    const res = Object.keys(obj).some(key => obj[key]?.toString()?.toLowerCase()?.includes(searchStr) || false)
    return res

  }

  const onSearch = (e) => {
    let filteredData = localData
    if (e.target.value) {
      setSearchValue(e.target.value)
      filteredData = localData.filter(row => filterItem(row, e.target.value))
    }

    setFilterdData(filteredData)

  }

  const onSort = (item) => {
    if (!item.sort) return
    const key = item.key
    let ordered = !(order[key])

    const results = Array.from(filteredData).sort((a, b) => {
      return (ordered) ?
        a[key]?.toString().localeCompare(b[key]?.toString())
        :
        b[key]?.toString().localeCompare(a[key]?.toString())
    })

    setFilterdData(results)

    setOrder(prev => ({ ...prev, [key]: ordered }))
  }
  return (

    <div className="w-full">
      <div className="flex flex-col justify-between my-2 md:flex-row">
        <div className="flex items-center justify-end w-full py-3 md:justify-start md:py-0">
          {CustomHeader && <CustomHeader />}
        </div>
        <div className="w-full flex-0 md:w-72 ">
          <div className="relative mt-1 rounded-md ">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <SearchIcon className="w-5 h-5 text-gray-400" aria-hidden="true" />
            </div>
            <input
              type="text"
              onChange={onSearch}
              className="block w-full pl-10 border-gray-300 rounded-md shadow-sm focus:ring-0 focus:border-gray-300 sm:text-sm"
              placeholder={t('component.table.search')}
            />
          </div>
        </div>
      </div>
      <div className="px-4 overflow-y-auto bg-white shadow">
        <table className="w-full whitespace-nowrap">
          <thead>
            <tr tabIndex="0" className="w-full h-16 text-sm leading-none text-gray-800 focus:outline-none">
              {
                columns.map((c, idx) => (
                  <th key={`h_${idx}`} className="pl-8 font-normal text-left capitalize">
                    {(c.key && (
                      <p className={classnames("flex items-center", { 'cursor-pointer': c.sort })} onClick={() => onSort(c)}>
                        {c.label || c.key}
                        {c.sort && (
                          <SwitchVerticalIcon className="w-4 h-4 ml-3 text-gray-400" aria-hidden="true" />
                        )}
                      </p>
                    ))}

                  </th>
                ))
              }
            </tr>
          </thead>
          {/* BODY */}
          <tbody className="w-full">
            {
              filteredData.slice(((pagination.page - 1) * pagination.show), ((pagination.page - 1) * pagination.show) + pagination.show)?.map((d, idx) => (
                <tr key={`b_${idx}`} tabIndex="0" className="text-sm leading-none text-gray-800 bg-white border-t border-b border-gray-100 focus:outline-none hover:bg-gray-100">
                  {renderColumn(d)}
                </tr>
              ))
            }</tbody>
        </table>
        <div className="flex justify-end mt-2">
          <Pagination items={filteredData} config={pagination} onSelected={(page) => setPagination(prev => ({ ...prev, page }))} />
        </div>
      </div>
    </div>
  )
}


const Pagination = ({ items, config, onSelected }) => {
  const { t } = useTranslation();

  const maxNumber = Math.ceil(items.length / config.show)
  const renderNumber = (c, m) => {
    var current = c,
      last = m,
      delta = 2,
      left = current - delta,
      right = current + delta + 1,
      range = [],
      rangeWithDots = [],
      l;

    for (let i = 1; i <= last; i++) {
      if (i == 1 || i == last || i >= left && i < right) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  }

  return (
    <div className="flex items-center justify-between w-full py-3 bg-white">
      <div className="flex justify-between flex-1 sm:hidden">
        <a
          href="#"
          className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Previous
        </a>
        <a
          href="#"
          className="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Next
        </a>
      </div>
      <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            {t('component.table.Showing')} <span className="font-medium">{(config.page * config.show) - (config.show - 1)}</span> {t('component.table.to')} <span className="font-medium">{config.page * config.show}</span> {t('component.table.of')}{' '}
            <span className="font-medium">{items.length}</span> {t('component.table.results')}
          </p>
        </div>
        <div>
          <nav className="relative z-0 inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
            <a
              href="#"
              onClick={() => {
                if (config.page > 1) onSelected(config.page - 1)
              }}
              className="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-md hover:bg-gray-50"
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="w-5 h-5" aria-hidden="true" />
            </a>
            {
              renderNumber(config.page, maxNumber).map((i) => (
                i === '...' ?
                  <span key={`page_dot`} className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300">
                    ...
                  </span>
                  :
                  <a
                    key={`page_${i}`}
                    onClick={() => onSelected(i)}
                    aria-current="page"
                    className={classnames('', {
                      'z-10 bg-primary-50 border-primary-200 text-primary-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium': i === config.page,
                      'cursor-pointer  bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium': i !== config.page,

                    })}
                  >
                    {i}
                  </a>
              ))
            }
            <a
              onClick={() => {
                if (maxNumber > config.page) onSelected(config.page + 1)
              }}
              href="#"
              className="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-md hover:bg-gray-50"
            >
              <span className="sr-only" >Next</span>
              <ChevronRightIcon className="w-5 h-5" aria-hidden="true" />
            </a>
          </nav>
        </div>
      </div>
    </div>
  )
}